import { JsonLd, productNode } from '@/lib/structuredData';

export const ProductStructuredData = ({ product }) => (
  <JsonLd data={{ '@context': 'https://schema.org', ...productNode(product) }} />
);
